module.exports = __webpack_public_path__ + "img/A05-20060217-001.1ca6b745.jpg";